var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC300",
  d: "M4.348 3a2.7 2.7 0 0 0-2.7 2.7v2.847c1.299.524 2.213 1.771 2.213 3.229 0 1.457-.914 2.705-2.213 3.228v2.847a2.7 2.7 0 0 0 2.7 2.7h2.76V3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDC30",
  d: "M21.9 8.547V5.701A2.7 2.7 0 0 0 19.2 3H7.11v17.55H19.2a2.7 2.7 0 0 0 2.7-2.7v-2.847c-1.298-.523-2.212-1.771-2.212-3.229 0-1.457.914-2.704 2.213-3.228"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D6B100",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.839,
  d: "M9.4 16.672s2.13.144 2.397-1.745"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D6B100",
  d: "M13.635 11.621s3.156-.601 3.592-1.358c.437-.757.143-1.38-.462-1.729a1.265 1.265 0 0 0-1.397.087c.06-.489-.17-.99-.623-1.253-.606-.35-1.293-.293-1.73.463-.436.757.621 3.79.62 3.79M13.372 12.074s-3.156.602-3.593 1.358-.142 1.38.464 1.73a1.265 1.265 0 0 0 1.397-.088c-.061.49.169.992.623 1.254.606.35 1.292.293 1.73-.463.436-.757-.622-3.79-.621-3.79M16.73 13.71c.489.061.99-.168 1.253-.623.35-.605.293-1.292-.463-1.729-.757-.437-3.79.62-3.79.62.003.002.6 3.156 1.357 3.593s1.38.142 1.73-.463a1.265 1.265 0 0 0-.088-1.398M13.275 11.717s-.603-3.157-1.358-3.593-1.38-.142-1.73.463a1.265 1.265 0 0 0 .088 1.397c-.49-.06-.992.17-1.254.624-.35.605-.293 1.292.463 1.729.757.437 3.79-.62 3.79-.62"
})));
export default SvgGiftBox;